import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { getProfileCVs } from '../StartCV/apiCaller';
import CardComponent from './CardComponent';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  color: #fff;
  background-color: #fff;
  width: 100%;
  padding-bottom: 100px;
`;

const Header = styled('div')`
  background: #08142f;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  display: flex;
  align-items: center;
  color: #ffffff;
  height: 40px;
  padding: 0 1rem 0 1rem;
`;

const ContentArea = styled('div')`
  background-color: #fff;
  padding-top: 15px;
  padding-left: 10px;
  padding-right: 10px;

  & .edit-link {
    color: var(--ui-link, #007aff);
    font-family: Source Sans Pro;
    font-size: 0.9375rem;
    font-weight: 600;
    line-height: 1.25rem; /* 133.333% */
  }

  & h2 {
    color: var(--gray-900, #1f1f1f);
    font-feature-settings:
      'clig' off,
      'liga' off;
    font-family: Source Sans Pro;
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5rem; /* 120% */
  }
`;
const MainContainer = styled('div')`
  & .detail-card-container {
    color: black;
  }
  & h2 {
    color: var(--gray-900, #1f1f1f);
    font-feature-settings:
      'clig' off,
      'liga' off;
    /* Source/Body 20/Regular */
    font-family: Source Sans Pro;
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5rem; /* 120% */
  }
  & .dept {
    color: #071c3e;
    text-align: left;
    /* Source/Body 15/Semibold */
    font-family: Source Sans Pro;
    font-size: 0.9375rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.25rem; /* 133.333% */
  }
  & .expereience {
    color: #919191;
    text-align: left;
    /* Source/Caption 12/Semibold */
    font-family: Source Sans Pro;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1rem; /* 133.333% */
  }
  & p {
    color: var(--gray-900, #1f1f1f);
    font-family: Source Sans Pro;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1rem; /* 133.333% */
  }
`;

const ButtonContainer = styled.div`
  margin-top: 20px;
`;

const UserProfileCV = () => {
  const navigate = useNavigate();
  const [existingCVInformation, setExistingCVInformation] = useState<any>([]);
  const [isAPICallCompleted, setIsAPICallCompleted] = useState(false);

  const refreshExistingCVs = async () => {
    setIsAPICallCompleted(false);
    const data = await getProfileCVs();
    const groupedData: any = {};

    data.forEach((item) => {
      const key = item.hotelName;
      if (!groupedData[key]) {
        groupedData[key] = [];
      }
      groupedData[key].push(item);
    });

    // Process the grouped data and wrap it into currentHotel or previousHotel objects
    const result: any = {};

    for (const key in groupedData) {
      if (groupedData.hasOwnProperty(key)) {
        const hotelGroup: any = groupedData[key];
        hotelGroup.sort((a: any, b: any) => {
          // Check if endDate is not available for both a and b
          if (!a.endDate && !b.endDate) {
            return 0; // No change in order since both have no endDate
          } else if (!a.endDate) {
            return -1; // Move a to the front since it has no endDate
          } else if (!b.endDate) {
            return 1; // Move b to the front since it has no endDate
          } else {
            // Both a and b have endDate, compare them
            const aStartDate: any = new Date(a.startDate);
            const bStartDate: any = new Date(b.startDate);
            return aStartDate - bStartDate;
          }
        });
        const isCurrentHotel = !hotelGroup[0].endDate;

        if (isCurrentHotel) {
          if (!result.currentHotel) {
            result.currentHotel = {};
          }
          result.currentHotel[key] = hotelGroup;
        } else {
          if (!result.previousHotel) {
            result.previousHotel = {};
          }
          result.previousHotel[key] = hotelGroup;
        }
      }
    }
    setIsAPICallCompleted(true);
    setExistingCVInformation(result);
  };

  useEffect(() => {
    refreshExistingCVs();
  }, []);
  return (
    <>
      <Container>
        <div className="pilot-header background-08142f w-100">
          <AppHeader navigateTo="/pilotwelcome" />
          <Header>Profile</Header>
          <ContentArea>
            <div className="d-flex space-between align-items-center">
              <h1 className="color-black">Luxury CV</h1>
              {existingCVInformation &&
                !!Object.entries(existingCVInformation).length && (
                  <div
                    className="edit-link"
                    onClick={() =>
                      navigate('/edit-cv', {
                        state: {
                          hotelData: existingCVInformation,
                        },
                      })
                    }
                  >
                    Edit
                  </div>
                )}
            </div>
            <MainContainer>
              {existingCVInformation.currentHotel &&
                !!Object.entries(existingCVInformation.currentHotel).length && (
                  <>
                    <h2>Current Hotel</h2>
                    <CardComponent
                      hotelsData={existingCVInformation.currentHotel}
                    />
                  </>
                )}
              {existingCVInformation.previousHotel &&
                !!Object.entries(existingCVInformation.previousHotel)
                  .length && (
                  <>
                    <h2>Previous Hotel</h2>
                    <CardComponent
                      hotelsData={existingCVInformation.previousHotel}
                    />
                  </>
                )}

              {isAPICallCompleted && (
                <ButtonContainer>
                  <ButtonLarge
                    onClick={() =>
                      navigate('/start-cv', {
                        state: { isPreviousHotelExperience: true },
                      })
                    }
                    title="Add Previous Hotel Experience"
                    outlined={true}
                    inverted={true}
                  />
                </ButtonContainer>
              )}
            </MainContainer>
          </ContentArea>
        </div>
      </Container>
    </>
  );
};
export default UserProfileCV;
